<template>
	<div class="height-100dvh">
		<header class="mob-back-header header-z-index">
			<img
				@click="goToPanelDashboard()"
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			{{ getLevelName(level) }}
		</header>
		<main class="become-panel-container app-bottom-padding mob-w100">
			<section
				v-if="panelInterviews[level].length == 0 || showLoader[level]"
				class="mobir-sub-container"
			>
				<PanelKanbanShimmer v-if="showLoader[level]" />
				<div
					class="h-100 d-flex align-items-center justify-content-center flex-column"
					v-else
				>
					<img src="@/assets/paneldashboard/nointerview.svg" alt="" />
					<div class="fs-14 fam-lat fw-LM color-344054">
						{{ getNoDataText(level) }}
					</div>
				</div>
			</section>
			<section
				v-else
				class="pd-kanban-cards mobile-int-cards mobir-sub-container"
				@scroll="scrollInt(level, $event)"
			>
				<section
					v-for="interview in panelInterviews[level]"
					:key="interview.interviewRequestID"
				>
					<InetrviewRequestCard
						:level="level"
						:interview="interview"
						:isLaptop="false"
						@cancel-interview="showCancelInterview(interview, $event)"
						@accept-reject="showAcceptRejectModal($event, interview)"
						@view-feedback="viewFeedbackData(interview)"
						@show-jobdetails="goToJobDetails($event, interview, level)"
						@gotofeedback="goToFeedback()"
					/>
				</section>
				<div class="text-center" v-if="spinners[level]">
					<b-spinner class="ml-auto"></b-spinner>
				</div>
			</section>
		</main>
		<JobDetailsModal
			v-if="showJobDetailsModal"
			:showJobDetailsModal="showJobDetailsModal"
			:interview="selectedInterview"
			:level="selectedLevel"
			@view-feedback="viewFeedbackData(selectedInterview)"
			@accept-reject="showAcceptRejectModal($event, selectedInterview)"
			@close-modal="hideJobDetails()"
			@gotofeedback="goToFeedback()"
		/>
		<ViewFeedback
			v-if="showViewFeedback"
			:showViewFeedback="showViewFeedback"
			:interview="selectedInterview"
			@close-modal="hideViewFeedback()"
		/>

		<AcceptRejectModal
			v-if="showAcceptReject || cancelInterview"
			:showAcceptReject="showAcceptReject || cancelInterview"
			:interview="selectedInterview"
			:type="actionType"
			:cancel="cancelInterview"
			@success="checkAndClose('success', $event)"
			@close-modal="checkAndClose('close')"
		/>
	</div>
</template>

<script>
import "@/assets/paneldashboard/paneldashboard.css";
import InetrviewRequestCard from "@/components/PanelDasboard/InetrviewRequestCard.vue";
import panelDashboardMixin from "@/components/mixin/panelDashboardMixin";

export default {
	name: "MobInterviewRequestCard",
	data() {
		return {
			level: null,
		};
	},
	mixins: [panelDashboardMixin],
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	created() {
		this.level = parseInt(this.$route.params.level);
		this.showLoader[this.level] = true;
		this.getPanelInterviews(this.level);
	},
	components: {
		InetrviewRequestCard,
	},
	methods: {
		closedFeedback(val) {
			if (val && val.submitted) {
				this.successModal("Success", "Feedback submitted successfully.");
				this.$router.push({ name: "PanelDashboard" });
			} else {
				this.$store.commit("candidateVUEX/setFeedbackData", {});
				this.$router.push({ name: "PanelDashboard" });
			}
		},
		goToFeedback() {
			let route = { name: "GiveFeedback" };
			if (this.$route.query.from && this.$route.query.level) {
				(route.query.backto = this.$route.query.from),
					(route.query.level = this.$route.query.level);
			}
			this.$router.push(route);
		},
		checkScreenSize() {
			let isLaptop = window.innerWidth >= 1024;
			if (isLaptop) this.$router.push({ name: "PanelDashboard" });
		},
		gotogivefeedback() {
			this.$router.push({ name: "GiveFeedback" });
		},
	},
};
</script>

<style>
.mobir-sub-container {
	background: #ffffff;
	border-radius: 4px;
	padding: 10px;
	height: 100%;
	overflow: auto;
}
@media (max-width: 1028px) {
	.mobile-int-cards {
		height: 100%;
		display: flex;
		width: 100%;
		overflow-x: auto;
		gap: 15px;
		flex-direction: column;
	}
	.mobile-int-cards .card {
		width: 100%;
	}
}
</style>
